import React, { useState, useEffect } from "react";
import "./RecentPosts.css";
import { Link } from "react-router-dom";
import { Message, Feed, Divider, Button, Icon } from "semantic-ui-react";
import RecentPost from "./Post/RecentPost";
import { useAuthContext } from "../../Hooks/useAuthContext";
import { usePostsContext } from "../../Hooks/usePostsContext";
import { useMetaData } from "../../Context/MetaDataContext";
import { isMobile } from "react-device-detect";
import noAvatar from "../../assets/img/noAvatar.png";
import { Helmet } from "react-helmet-async";
const RecentPosts = () => {
  const { posts, dispatch } = usePostsContext();
  const [error, setError] = useState(null);
  const { user } = useAuthContext();
  const { metaData } = useMetaData();
  const [recentPosts, setRecentPosts] = useState([]);
  // GET THE POSTS DATA FROM BACKEND
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`/api/posts/recent`);
        if (response.ok) {
          const json = await response.json();
          setRecentPosts(json); // ✅ separate local state
        } else {
          throw new Error("Failed to fetch posts");
        }
      } catch (error) {
        setError(error.message);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      {/* <Helmet>
        <title>Trading Plan - We Win Together</title>
      </Helmet> */}
      <div
        className="RecentPosts"
        style={{
          display: "flex",
          overflowY: "scroll",
          maxHeight: "300px",
        }}
      >
        {error && <div>{error}</div>}
        <Divider horizontal>
          <span className="RecentPostsTitle">
            {metaData.CATEGORY.RECENT_POST}
          </span>
        </Divider>
        <Feed size="large">
          {recentPosts &&
            recentPosts.map((post, index) => (
              <RecentPost
                post={post}
                key={post._id}
                index={index + 1} // pass number from 1 to 10
              />
            ))}
        </Feed>
      </div>
    </>
  );
};

export default RecentPosts;
